import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Typography, Chip, Button } from '@mui/material';
import { Invoice, InvoiceType } from 'models/invoice';
import InvoiceCertificationStatus from 'components/invoices/invoice-item/invoice-certification-status/invoice-certification-status.component';
import { Order } from 'models/order';
import DoneIcon from '@mui/icons-material/Done';

type InvoiceCertifyProps = {
    invoice: Invoice;
    lineItemWithOrderCount: number;
    certifiedOrderCount: number;
    openPriceSpecDialog: () => void;
};
const InvoiceCertify: FC<InvoiceCertifyProps> = ({
    invoice,
    lineItemWithOrderCount,
    certifiedOrderCount,
    openPriceSpecDialog,
}: InvoiceCertifyProps) => {
    const { t: translate } = useTranslation(['orders', 'invoices']);

    if (invoice.invoiceType === InvoiceType.SINGLE) {
        if ((invoice.order as Order).isCertified) {
            return <Chip label={translate('orders:CERTIFIED')} color="success" />;
        }
        return (
            <Button startIcon={<DoneIcon />} onClick={() => openPriceSpecDialog()}>
                {translate('orders:CERTIFY')}
            </Button>
        );
    }
    return (
        <Box display="flex" flex="0 0 auto">
            <Box mr={1}>
                <Typography variant="subtitle2">{translate('CERTIFICATION')}</Typography>
            </Box>
            <InvoiceCertificationStatus
                lineItemWithOrderCount={lineItemWithOrderCount}
                certifiedOrderCount={certifiedOrderCount}
            />
        </Box>
    );
};

export default InvoiceCertify;
